<template>
    <div class="assignment-feedback apprentice-simple-card">
        <div class="create">
            <div class="component-title">
                <h5 class="title">Feedback</h5>
            </div>

            <div
                class="message-list apprentice-messages-widget"
                v-if="feedbackIn.length"
                ref="messageListContainer">
                <div
                    class="message-item"
                    v-for="(message, messageKey) in feedbackIn"
                    :key="message.id"
                    :class="message.user_id === $authUser.id ? 'left' : 'right'">
                    <div class="user-info">
                        <div class="credentials">{{ message.user.full_name }}</div>
                        <div class="date">{{ message.created_at | date_time_om }}</div>
                        <div
                            class="message-maintenance"
                            v-if="canEdit(message)">
                            <b-button
                                class="btn-edit-message"
                                variant="primary-icon"
                                @click="showFeedbacks(message.id)">
                                <i class="fas fa-fw fa-pencil"></i>
                            </b-button>
                            <b-button
                                class="btn-delete-message"
                                variant="danger-icon"
                                @click="removeFeedback(message.id)">
                                <i class="fa fa-fw fa-trash"></i>
                            </b-button>
                        </div>
                    </div>
                    <div class="message-block">
                        <div
                            class="textmessage"
                            v-if="wordCount(message.text, 50)">
                            {{ getMessagePart(message.message, true, 50) }}
                            <b-button
                                class="btn-link-type btn-show-all"
                                v-b-toggle="`read-further-${message.id}`"
                                variant="primary">
                                {{ $t('assignment.show_more') }}
                            </b-button>
                            <b-collapse
                                class="read-further"
                                :id="`read-further-${message.id}`">
                                {{ getMessagePart(message.text, false, 50) }}
                                <b-button
                                    class="btn-show-less"
                                    v-b-toggle="`read-further-${message.id}`"
                                    variant="primary">
                                    {{ $t('assignment.hide') }}
                                </b-button>
                            </b-collapse>
                        </div>
                        <div
                            class="textmessage"
                            v-else>
                            {{ message.text }}
                        </div>
                        <div class="avatar">
                            <b-avatar
                                variant="primary"
                                size="3rem"
                                :src="getProfileImage(message)">
                            </b-avatar>
                        </div>
                    </div>

                    <design-2021-assignment-show-edit-feedback-modal-component
                        :feedback-in="message"></design-2021-assignment-show-edit-feedback-modal-component>
                </div>
            </div>

            <b-form-group label-for="teachers-assignment-feedback-input">
                <b-form-textarea
                    class="apprentice-textarea"
                    id="teachers-assignment-feedback-input"
                    v-model="text"
                    placeholder="Voer feedback in"
                    rows="3"
                    max-rows="6">
                </b-form-textarea>
            </b-form-group>
            <b-button
                class="btn-save btn-add-feedback"
                variant="primary"
                @click="storeFeedback">
                {{ $t('common.save') }}
            </b-button>
        </div>
    </div>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-assignment-edit-feedback-component',
    props: {
        feedbackIn: {
            type: Array,
            default: function () {
                return [];
            },
        },
        assignmentIn: Object,
        projectId: Number,
    },
    data() {
        return {
            text: this.feedbackIn ? this.feedbackIn.text : '',
        };
    },
    watch: {
        feedbackIn: function (feedback) {
            this.text = feedback.text;
        },
    },
    computed: {
        disabled() {
            return !this.text;
        },

        feedbacks() {
            const feedbacks = [];

            if (this.assignmentIn) {
                if (this.assignmentIn.feedback) {
                    feedbacks.push({
                        name: this.assignmentIn.name,
                        type: 'assignment',
                        order: 0,
                        id: this.assignmentIn.id,
                        feedback: this.assignmentIn.feedback.text,
                        feedback_user: this.assignmentIn.feedback.user.full_name,
                        feedback_time: this.assignmentIn.feedback.created_at,
                        profile_image: this.assignmentIn.feedback.user.profileimage
                            ? this.assignmentIn.feedback.user.profileimage.file.public_path
                            : '/images/default_avatar_profile.jpg',
                    });
                }

                for (const subAssignment of this.assignmentIn.sub_assignments) {
                    if (subAssignment.feedback) {
                        feedbacks.push({
                            name: subAssignment.name,
                            type: 'sub-assignment',
                            id: subAssignment.id,
                            order: subAssignment.order,
                            feedback: subAssignment.feedback.text,
                            feedback_user: subAssignment.feedback.user.full_name,
                            feedback_time: subAssignment.feedback.created_at,
                            profile_image: subAssignment.feedback.user.profileimage
                                ? subAssignment.feedback.user.profileimage.file.public_path
                                : '/images/default_avatar_profile.jpg',
                        });
                    }
                }

                feedbacks.sort((a, b) => (a.feedback_time > b.feedback_time ? 1 : -1)).reverse();
            }

            return feedbacks;
        },
    },
    methods: {
        getProfileImage(message) {
            if (message.user.profileimage) {
                return message.user.profileimage.file.public_path;
            } else if (this.profileImageIn && this.profileImageIn.file) {
                return this.profileImageIn.file.public_path;
            }

            return '/images/default_avatar_profile.jpg';
        },

        getMessagePart(message, firstPart, limit) {
            let rawMessage = message;
            if (firstPart) {
                return rawMessage.split(' ').splice(0, limit).join(' ') + ' ...';
            }
            return rawMessage.split(' ').splice(limit).join(' ');
        },

        storeFeedback() {
            const data = {
                assignment_id: this.assignmentIn.id,
                text: this.text,
                project_id: this.projectId,
            };

            this.axios.post(this.routes.assignmentFeedback(), data).then(
                (response) => {
                    this.assignmentIn.addRelation('feedback', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        removeFeedback(id) {
            this.alert
                .confirm(this.$t('assignment.delete_feedback_are_you_sure_you_want_to_delete_feedback'))
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.alert.saving();
                    this.axios.delete(this.routes.assignmentFeedbackRemove(id)).then(
                        (response) => {
                            ords.use('assignmentFeedback').remove(id);
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },

        showFeedbacks(id) {
            this.$bvModal.show('assignment-show-edit-feedback-modal' + id);
        },

        canEdit(message) {
            return message.user_id === this.$authUser.id;
        },

        wordCount(message, limit) {
            return message.split(' ').length > limit;
        },
    },
};
</script>

<style scoped lang="scss">
.message-item {
    &:hover {
        .user-info {
            .credentials,
            .date {
                font-weight: $font-weight-bold;
            }

            .message-maintenance {
                opacity: 1;
            }
        }
    }
}

.user-info {
    position: relative;

    .message-maintenance {
        position: absolute;
        right: 0;
        display: flex;
        align-content: center;
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
        z-index: 5;

        .btn {
            font-size: $default-font-size;

            &:not(:last-child) {
                margin-right: map-get($grid-gutter-spacing, 'eight');
            }
        }
    }
}

.compose-message {
    margin-top: $grid-gutter-width;
}

.feedback-display {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.latest-feedback {
    .b-avatar {
        height: 4.5rem;
        width: 4.5rem;
        margin-top: map-get($grid-gutter-spacing, 'fifteen');
    }

    .latest-feedback-title {
        .title {
            font-weight: $font-weight-bold;
        }
    }

    .credentials {
        .name {
            font-weight: $font-weight-bold;
        }

        .date {
            color: $text-muted-color;
            font-size: 0.75rem;
        }
    }

    .latest-feedback-content {
        display: flex;
        flex-direction: column;
        border-top-right-radius: $border-radius-content;
        border-bottom-left-radius: $border-radius-content;
        border-bottom-right-radius: $border-radius-content;
        background-color: $secondary-background-color;
        padding: map-get($grid-gutter-spacing, 'twenty-one');
        position: relative;

        .feedback-message {
            margin-top: map-get($grid-gutter-spacing, 'fifteen');
        }

        .btn-show-feedbacks-details {
            flex: 1 0 100%;
            justify-content: flex-end;
        }

        &:before {
            content: '';
            position: absolute;
            display: block;
            border-top: 1em solid $secondary-background-color;
            border-left: 1em solid transparent;
            top: 0;
            left: -14px;
        }
    }
}
</style>
